﻿const objects = [
    'ball',
    'cat',
    'dog',
    'squirrel',
    'coconut',
    'lemon',
    'apple',
    'pineapple',
    'hippo',
    'horse',
    'cupcake',
    'moon',
    'cityscape',
    'sun',
    'stars',
    'badger',
    'meerkat',
    'panda',
];
const places = [
    'beach',
    'grassy field',
    'desert',
    'landscape',
    'town square',
    'city street',
    'forest',
    'mountain range',
    'valley',
    'jungle',
    'rainforest',
    'tundra',
    'salt flats',
];

const nouns = [
    'A cat',
    'A coconut',
    'A ball',
    'A dog',
    'A superhero',
    'A goat',
    'A squirrel',
    'A horse',
    'A cow',
    'A duck',
    'A goose',
    'A bear',
    'A lion',
    'A zebra',
    'A hippo',
];
const contexts = ['in a crowd', 'at the beach', 'in the forest', 'at the office', 'outdoors', 'in a field', 'in the desert'];
const ending = ['with a sunset in the background', 'with a party in the background', 'with mountains in the background', 'with a forest in the background'];

export interface AiImageGenerationExample {
    Text: string;
    Categories: AiImageCategory[];
}

export interface AiImageCategory {
    Text: string;
    Options: AiImageDropdownOption[];
    SelectedOptions: string[];
}

export interface AiImageDropdownOption {
    Text: string;
}

export function getSentencePromptExample(): string {
    let sentence = '';

    var randomNoun = getRandomItemFromArray(nouns);
    var randomContext = getRandomItemFromArray(contexts);
    var randomEnding = getRandomItemFromArray(ending);

    sentence += `${randomNoun} ${randomContext}`;

    var randomNumber = Math.random();
    if (randomNumber < 0.33) {
        sentence += ` ${randomEnding}`;
    }

    return sentence;
}

function getKeywordsPromptExample() {
    let text = '';

    //generate text from objects & places
    var randomObject = getRandomItemFromArray(objects);
    var objectWeights = { 1: 1, 2: 0.0, 3: 0.0 };
    var objectsToSelect = weightedRandom(objectWeights);

    for (let index = 0; index < objectsToSelect; index++) {
        var randomObject = getRandomItemFromArray(objects);

        if (!text.includes(randomObject)) {
            if (text == '') {
                text = `${randomObject}`;
            } else {
                text += `, ${randomObject}`;
            }
        }
    }

    var randomPlace = getRandomItemFromArray(places);
    text += `, ${randomPlace}`;

    return text;
}

export function getGenerationExample(): AiImageGenerationExample {
    var generationExample: AiImageGenerationExample = {
        Text: '',
        Categories: getImageCategories(),
    };

    var randomNumber = Math.random();
    if (randomNumber < 0.5) {
        generationExample.Text = getSentencePromptExample();
    } else {
        generationExample.Text = getKeywordsPromptExample();
    }

    //select dropdown options per "category"
    var categoryWeights = { 1: 0.45, 2: 0.45, 3: 0.1 };
    var categoriesToSelect = weightedRandom(categoryWeights);
    for (let index = 0; index < categoriesToSelect; index++) {
        var randomCategory = getRandomItemFromArray(generationExample.Categories);
        var randomOption = getRandomItemFromArray(randomCategory.Options);

        var category = generationExample.Categories.find((c) => c.Text == randomCategory.Text);

        if (category?.SelectedOptions.length == 0) {
            category?.SelectedOptions.push(randomOption.Text);
        } else {
            index--;
        }
    }

    return generationExample;
}

export function getImageCategories(): AiImageCategory[] {
    var categories: AiImageCategory[] = [
        {
            Text: 'Type',
            Options: [
                {
                    Text: 'Image',
                },
                {
                    Text: 'Watercolor',
                },
                {
                    Text: 'Illustration',
                },
                {
                    Text: 'Coloring pages',
                },
                {
                    Text: 'Tattoo design',
                },
                {
                    Text: 'Album cover',
                },
                {
                    Text: 'Poster',
                },
                {
                    Text: 'Art',
                },
                {
                    Text: 'Nail art',
                },
                {
                    Text: 'Outlines',
                },
                {
                    Text: 'Logo',
                },
                {
                    Text: 'Drawing',
                },
            ],
            SelectedOptions: [],
        },
        {
            Text: 'Style',
            Options: [
                {
                    Text: 'Realism',
                },
                {
                    Text: 'Abstract expressionism',
                },
                {
                    Text: 'Art deco',
                },
                {
                    Text: 'Cinematic',
                },
                {
                    Text: 'Childrens book illustration',
                },
                {
                    Text: 'Cartoon',
                },
                {
                    Text: 'Brutalism',
                },
                {
                    Text: 'Conceptual art',
                },
                {
                    Text: 'Expressionism',
                },
                {
                    Text: 'Minimalist',
                },
                {
                    Text: 'Retro',
                },
                {
                    Text: 'Colorful',
                },
            ],
            SelectedOptions: [],
        },
        {
            Text: 'Lighting',
            Options: [
                {
                    Text: 'Blacklight',
                },
                {
                    Text: 'Dreamy glow',
                },
                {
                    Text: 'Lens flare',
                },
                {
                    Text: 'Starry',
                },
                {
                    Text: 'Sunlit',
                },
                {
                    Text: 'Moonlit',
                },
                {
                    Text: 'Natural light',
                },
                {
                    Text: 'Neon lights',
                },
                {
                    Text: 'Floodlight',
                },
                {
                    Text: 'Backlit',
                },
            ],
            SelectedOptions: [],
        },
        {
            Text: 'Camera',
            Options: [
                {
                    Text: 'Motion blur',
                },
                {
                    Text: 'Night vision',
                },
                {
                    Text: 'Oblique angle',
                },
                {
                    Text: 'Panoramic view',
                },
                {
                    Text: 'Polaroid camera',
                },
                {
                    Text: 'Split focus',
                },
                {
                    Text: 'Stereoscopic 3D',
                },
                {
                    Text: 'Time-lapse',
                },
                {
                    Text: 'Vintage look',
                },
                {
                    Text: 'Abstract perspective',
                },
                {
                    Text: 'Dutch angle',
                },
                {
                    Text: 'Film noir style',
                },
                {
                    Text: 'Aerial Photography',
                },
                {
                    Text: 'Closeup',
                },
                {
                    Text: 'Far Shot',
                },
                {
                    Text: 'Focal Blur',
                },
                {
                    Text: 'Out Of Focus',
                },
                {
                    Text: 'Portrait Photography',
                },
                {
                    Text: 'Selfie',
                },
                {
                    Text: 'Tilt shift',
                },
                {
                    Text: 'Wide Angle',
                },
                {
                    Text: 'Rain drops on lens',
                },
                {
                    Text: 'Smears on lens',
                },
                {
                    Text: 'Smudges on lens',
                },
                {
                    Text: 'Ultra Wide Angle',
                },
            ],
            SelectedOptions: [],
        },
        {
            Text: 'Mood',
            Options: [
                {
                    Text: 'Serene',
                },
                {
                    Text: 'Peaceful',
                },
                {
                    Text: 'Vibrant',
                },
                {
                    Text: 'Bright',
                },
                {
                    Text: 'Romantic',
                },
                {
                    Text: 'Lively',
                },
                {
                    Text: 'Bleak',
                },
                {
                    Text: 'Somber',
                },
                {
                    Text: 'Gloomy',
                },
                {
                    Text: 'Dark mood',
                },
            ],
            SelectedOptions: [],
        },
        {
            Text: 'Color',
            Options: [
                {
                    Text: 'Red',
                },
                {
                    Text: 'Blue',
                },
                {
                    Text: 'Green',
                },
                {
                    Text: 'Yellow',
                },
                {
                    Text: 'White',
                },
                {
                    Text: 'Black',
                },
                {
                    Text: 'Pink',
                },
                {
                    Text: 'Gold',
                },
                {
                    Text: 'Black and white',
                },
                {
                    Text: 'Colorful',
                },
                {
                    Text: 'Rainbow colors',
                },
            ],
            SelectedOptions: [],
        },
        {
            Text: 'Material',
            Options: [
                {
                    Text: 'made of copper',
                },
                {
                    Text: 'made of vegetables',
                },
                {
                    Text: 'made of gold',
                },
                {
                    Text: 'made of metal',
                },
                {
                    Text: 'made of amber',
                },
                {
                    Text: 'made of amethyst',
                },
                {
                    Text: 'made of wood',
                },
                {
                    Text: 'made of ceramic',
                },
                {
                    Text: 'made of candy',
                },
                {
                    Text: 'made of stone',
                },
            ],
            SelectedOptions: [],
        },
    ];

    return categories;
}

function getRandomItemFromArray<T>(array: T[]) {
    var randomNumber = Math.floor(Math.random() * array.length);

    return array[randomNumber];
}

function weightedRandom(spec: any): number {
    var i,
        sum = 0,
        r = Math.random();

    for (i in spec) {
        sum += spec[i];
        if (r <= sum) return +i;
    }
    return 0;
}
